import { CellContext } from "@tanstack/react-table";
import { memo } from "react";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { TransactionSplitColumnContent } from "../ListItem/TransactionSplitColumnContent";

export const SplitCell = memo(
    ({ row }: CellContext<TransactionListItemDto, any>) => (
        <TransactionSplitColumnContent
            transaction={row.original}
            hasAdjacentSplitSibling={false}
            onClick={() => {}}
        />
    ),
);
